import ProductFeatures from "../Common/ProductFeatures";
import SiteTypeOptions from "../Common/SiteTypeOptions";
import { PRICE_LIST, PriceListType } from "src/config/priceTypeList";
import { getProductInfo } from "src/utils/storage/product";
import { IPayDataType } from "components/Common/Inicis/ReactInicis";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { productInfo as productInfoNameMap } from "src/config/config";
import { SetStateAction } from "react";
import CouponCodeRow from "components/Site/Common/Form/FormItem/CouponCode";
import ServicePaymentInfoRow from "../Common/Form/FormItem/ServicePaymentInfoRow";
import CardPayment from "../Common/Form/Payment/CardPayment";
import CashPayment from "../Common/Form/Payment/CashPayment";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface IRightDetailBoxProps {
  userPerPriceYear: number;
  userPerPrice: number;
  currency: string;
  payCompany: string;
  inicisData: IPayDataType;
  startDate: string;
  planId: string;
  showTaxInvoiceFields: boolean;
  toggleTaxInvoidFields: () => void;
  taxInvoiceInfo: any;
  handleChangeTaxInvoice: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleChangeTaxRequestDate: (date: Date | null) => void;
  selectAppList: string[];
  setSelectAppList: React.Dispatch<SetStateAction<string[]>>;
}
const RightDetailBox = ({
  userPerPriceYear,
  userPerPrice,
  currency,
  payCompany,
  inicisData,
  startDate,
  planId,
  showTaxInvoiceFields,
  toggleTaxInvoidFields,
  taxInvoiceInfo,
  handleChangeTaxInvoice,
  handleChangeTaxRequestDate,
}: IRightDetailBoxProps) => {
  const { watch } = useFormContext();
  const licenseCount = watch("licenseCount");
  const selectPayType = watch("selectPayType");
  const priceType = watch("priceType");
  const { t } = useTranslation();
  const productInfo = PRICE_LIST({ t })[getProductInfo().key].filter(
    (item: PriceListType) => item.key === priceType
  )[0] ?? {
    key: "",
    name: "",
    featuresCnt: 0,
    upcCnt: -1,
  };

  const productKey = getProductInfo().key;
  // const { isOciProduct } = useIsOciProduct();
  const setGoodName = () => {
    const product = getProductFromSessionStorage();
    return `${productInfoNameMap[product].name} Cloud`;
  };
  const paypalSubscription = (data: any, actions: any) => {
    console.log("paypalSubscription", planId);
    if (startDate) {
      return actions.subscription.create({
        quantity: licenseCount,
        plan_id: `${planId}`,
        start_time: startDate + "Z",
      });
    } else {
      return actions.subscription.create({
        quantity: licenseCount,
        plan_id: `${planId}`,
        // plan_id: "P-4CD28116DL485711CL6GR2OI",
      });
    }
  };
  return (
    <div className="flex-item box box__rt bg-white">
      <SiteTypeOptions
        productKey={productKey}
        // priceType={values?.priceType}
        // handleChange={handleChange}
      />
      <ProductFeatures
        productKey={productKey}
        // priceType={values?.priceType}
        // productInfo={productInfo}
      />
      <hr />
      {/* UPC는 루모스에서 세팅 */}
      {/* {!isOciProduct && (
          <UpcList
            productInfo={productInfo}
            selectAppList={selectAppList}
            setSelectAppList={setSelectAppList}
            // applicationList={applicationList}
            // selectAppList={selectAppList}
            // handleChange={handleChange}
            // openExtDetailModal={openExtDetailModal}
          />
        )} */}

      {/*
          <button
            type="button"
            disabled={!isCheckPay}
            onClick={payApply}
            className="btn btn-green width w-100p pd py-10"
          >
            신청하기
          </button>
*/}
      {/* 서비스 구독 & 결제 정보 */}
      <ServicePaymentInfoRow
        userPerPrice={userPerPrice}
        userPerPriceYear={userPerPriceYear}
        payCompany={payCompany}
        currency={currency}
      />
      {/* 할인 쿠폰 */}
      <CouponCodeRow />
      {selectPayType === "card" && (
        <CardPayment
          payCompany={payCompany}
          inicisData={inicisData}
          currency={currency}
          setGoodName={setGoodName}
          // isCheckPay={isCheckPay}
          paypalSubscription={paypalSubscription}
          // sendPaypalSuccessMail={sendPaypalSuccessMail}
        />
      )}
      {selectPayType === "cash" && (
        <CashPayment
          showTaxInvoiceFields={showTaxInvoiceFields}
          toggleTaxInvoidFields={toggleTaxInvoidFields}
          taxInvoiceInfo={taxInvoiceInfo}
          handleChangeTaxInvoice={handleChangeTaxInvoice}
          handleChangeTaxRequestDate={handleChangeTaxRequestDate}
        />
      )}
      {/* <PaymentSection /> */}
      {/* <hr />
        <span className="form-item-title">
          {t("siteType.referralIdOptional")}
        </span>
        <div>
          <input
            id="referralId"
            name="referralId"
            value={referralId}
            onChange={handleChange}
            className="form-control custom-form width w-370"
            placeholder={t("siteType.enterIdEmail")}
          />
        </div> */}
    </div>
  );
};

export default RightDetailBox;
